module.exports = __webpack_public_path__ + "img/product4ap.e9bc1273.png";